import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import type { DesignerNode } from "../types/index.ts";
import { resolveAvailableValuesSelector } from "./valueSelectors.ts";

const resolveAvailableValuesForNodeSelector = createSelector(
  [resolveAvailableValuesSelector],
  (resolveAvailableValues) => (nodeOrId: DesignerNode | number) =>
    resolveAvailableValues(typeof nodeOrId === "number" ? nodeOrId : nodeOrId.id),
);

export const useResolveAvailableValues = () => useSelector(resolveAvailableValuesForNodeSelector);
